module.exports = __webpack_public_path__ + "static/media/bgml.94bd1a74.png";